import { BaseModel } from "@core/base.model";
import { Email } from "@core/types/email.type";

export class Company extends BaseModel {
  name: string = "";
  email: string = "";
  site: string = "";
  address: string = "";
  addressNumber: string = "";
  neighborhood: string = "";
  city: string = "";
  state: string = "";
  zipCode: string = "";
  telephone: string = "";
  docto: string = "";

  static build(dto: Company) {
    const entity = new Company(dto.id, dto.createdAt, dto.updatedAt);
    entity.name = dto.name;
    entity.email = dto.email;
    entity.site = dto.site;
    entity.address = dto.address;
    entity.addressNumber = dto.addressNumber;
    entity.neighborhood = dto.neighborhood;
    entity.city = dto.city;
    entity.state = dto.state;
    entity.zipCode = dto.zipCode;
    entity.telephone = dto.telephone;
    entity.docto = dto.docto;
    if (!entity.name || entity.name.length < 3) throw new Error("Informe o nome da empresa.");
    if (!Email.build(entity.email).validate()) throw new Error("E-mail inválido.");
    return entity;
  }
}
